module.exports = __webpack_public_path__ + "img/lemon-right-3.6f8bbd25.png";